<main>
  <ng-container *ngIf="(orderStatus$ | async) !== OrderStatus.PENDING; else loader">
    <ng-container *ngIf="passengers$ | async">
      <fin-check-in-passenger-details
        class="block"
        [order$]="order$"
        [bound$]="bound$"
        [passengers$]="passengers$"
        [modifyCheckIn]="modifyCheckIn$ | async"
        [controlData$]="controlData$"
        [mainPaxInfo$]="mainPaxInfo$"
        [allFrequentFlyerCards$]="allFrequentFlyerCards$"
        [confirmButtonLoading$]="clearingSeatsInProgress$"
        [isAPISRequired$]="isAPISRequired$"
        (confirmPassengers)="confirmPassengersForCheckIn($event)"
        (prefetchSeatmap)="prefetchSeatMaps($event)"
      ></fin-check-in-passenger-details>
    </ng-container>
  </ng-container>
</main>

<ng-template #loader>
  <div class="align-center fill">
    <fin-loader aria-live="polite" [type]="LoaderType.EMBEDDED" [waitingFor]="'MMB.checkIn.loadingOrder'"></fin-loader>
  </div>
</ng-template>
